import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={enUS}
      pagination={{
        showSizeChanger: true,
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
